export var globalStyles = "\n  #root {\n    background-color: white;\n  }\n  #root > div:first-child {\n    background-color: white;\n  }\n";